import React from 'react';

import { NextPage } from 'next';

import { PartnersPage } from '../components';

const PartnersNextPage: NextPage = () => {
  return <PartnersPage />;
};

// eslint-disable-next-line import/no-default-export
export default PartnersNextPage;
